// Simulated conversation engine for the prototype.
// FUTURE INTEGRATION: swap these deterministic responders for a real LLM /
// OpenAI Realtime call. Keep the same (employee, text) -> string signature.

function pick(map, text, fallback) {
  const t = text.toLowerCase();
  for (const [keys, reply] of map) {
    if (keys.some((k) => t.includes(k))) return reply;
  }
  return fallback;
}

export function employeeReply(employee, text) {
  const name = employee.name;
  const common = [
    [["approve", "approval", "waiting"], "Two items are waiting for you: the Franklin County field-service visit ($185) and Atlas's electrode-pad order ($780). Both are in the Approval Center."],
    [["exception", "issue", "problem"], "There are eleven AED exceptions today. Six are already resolved, three sites have been contacted, and two need your approval."],
    [["hours", "saved", "cost"], "So far this month the team has saved an estimated 156 hours against roughly $1,240 in operating cost."],
    [["hello", "hi", "morning", "hey"], `Hello Lewis. ${employee.greeting}`],
    [["thank"], "Happy to help. I'll keep monitoring and flag anything that needs you."],
  ];

  const perEmployee = {
    ava: [
      [["cs-1048", "1048", "franklin"], "AED CS-1048 at Franklin County Courthouse is reporting a red-X readiness condition. Atlas confirmed the replacement battery, Nora contacted the site, and Miles has prepared the field-service request for your approval."],
      [["today", "summary", "brief"], "Good morning, Lewis. Eleven devices require attention today. Six issues are resolved, three locations contacted, and two decisions need your approval."],
      [["site", "contacted", "manager"], "Three locations have been contacted so far: Franklin County, Riverside Community Center, and Northgate Mall."],
    ],
    miles: [
      [["schedule", "visit", "field"], "Three field-service visits are scheduled this week. I'm still waiting on confirmation from Franklin County before I lock the technician."],
      [["unreachable", "confirm", "franklin"], "Franklin County hasn't confirmed yet. If I don't hear back within the window, I'll escalate to Ava."],
    ],
    nora: [
      [["question", "answered", "how many"], "I answered 28 customer questions today and prepared tomorrow's onboarding session."],
      [["onboarding", "ready"], "Tomorrow's onboarding is ready — agenda built, materials attached, and the welcome email drafted for your review."],
      [["upset", "angry", "complaint"], "No upset customers right now. If one comes up, I'll offer a callback window and flag it to you immediately."],
    ],
    atlas: [
      [["compliance", "gap", "missing", "record"], "The compliance review is complete. I found two records with missing inspection documentation — I've listed the device IDs for follow-up."],
      [["battery", "cs-1048", "model", "replacement"], "Verified: CS-1048 requires part CS-BATT-4. It matches the current manufacturer specification."],
      [["overdue", "inspection"], "No overdue inspections at this time. Two are approaching their window and I'm tracking them."],
    ],
  };

  return pick(
    [...(perEmployee[employee.id] || []), ...common],
    text,
    `I'm ${name}, your ${employee.title}. I can help with "${text.trim()}". In the full product I'd pull the live records and act within my authority level — for now this is a simulated response.`
  );
}

export function interviewReply(role, question) {
  const q = question.toLowerCase();
  const R = {
    generic: {
      do: `As your ${role.title}, I take ownership of ${role.desc.toLowerCase()} I work continuously, keep a full activity trail, and only act within the authority you grant me.`,
      upset: "I'd stay calm, acknowledge the concern, resolve what I can within my authority, and offer a callback window. Anything sensitive I escalate to you with full context.",
      escalate: "I escalate anything sensitive — payments, contracts, large purchases, or decisions outside my authority — and anything I'm not confident about. You stay in control of those.",
      systems: `I connect to the tools your team already uses. For this role that typically means ${role.capabilities.join(", ").toLowerCase()} — and I structure cleanly for CRM, email and workflow integrations.`,
      report: "Everything I do is logged with a timestamp, the source I used, the action I took, and the result — so you can inspect or reverse any step.",
    },
  };
  const g = R.generic;
  if (q.includes("do for my business") || q.includes("what can you")) return g.do;
  if (q.includes("upset")) return g.upset;
  if (q.includes("escalate")) return g.escalate;
  if (q.includes("system")) return g.systems;
  if (q.includes("completed") || q.includes("know what")) return g.report;
  return `Great question. As your ${role.title}, I'd handle that as part of ${role.desc.toLowerCase()} and keep you informed every step of the way.`;
}
